import { Currency } from "./constants";

export const convertPrice = (
  priceInDin: number,
  currency: Currency,
  conversionRate: number
): number => {
  if (currency === "KM" && conversionRate > 0) {
    return Math.round((priceInDin / conversionRate) * 100) / 100;
  }
  return priceInDin;
};

export const getCurrencyLabel = (currency: Currency): string => {
  // RSD, the international code: Banca Intesa does not accept "din" as the currency mark.
  return currency === "KM" ? "KM" : "RSD";
};
